export enum RouteNames {
  Classes = 'Classes'
}
